<app-loader [isLoading]="isLoading"></app-loader>

<!-- Hidden file input for PDF uploads -->
<input type="file" id="menuFileInput" accept=".pdf,application/pdf" style="display: none;"
    (change)="onFileSelected($event)">

<div class="header">
    <div class="top">
        <a routerLink="/home/dining/general">
            <h3>Comedor /</h3>
            <div class="breadcrumb">
                <mat-icon svgIcon="arrow back"></mat-icon>
                <h2> Editar menús</h2>
            </div>
        </a>
    </div>
</div>
<div class="content">
    <div class="monthly-menu">
        <h3>SUBA LOS MENÚS DE CADA MES</h3>
        <div class="year">
            <button mat-icon-button (click)="changeYear(-1)">
                <mat-icon>chevron_left</mat-icon>
            </button>
            <h2>{{currentYear}}</h2>
            <button mat-icon-button (click)="changeYear(1)">
                <mat-icon>chevron_right</mat-icon>
            </button>
        </div>
        <mat-divider></mat-divider>
        <div class="months">
            @for(monthData of displayedMonths; track monthData.monthIndex) {
            <h4>{{monthData.month}}</h4>
            @if (monthData.menu && !monthData.menu.is_deleted) {
            <div class="menu">
                <p (click)="openPdfFile(monthData.menu!.pdf_file)" style="cursor: pointer">
                    {{getDisplayFilename(monthData.menu!.pdf_file, monthData.menu!.id)}}</p>
                <button mat-icon-button (click)="deleteMenu(monthData)"><mat-icon svgIcon="delete"></mat-icon></button>
            </div>
            } @else {
            <div class="upload">
                <button (click)="openFileUploader(monthData.monthIndex)">Subir menú</button>
            </div>
            }
            <mat-divider></mat-divider>
            }
        </div>
        <div class="buttons">
            <button mat-flat-button id="action" (click)="saveChanges()">Guardar cambios</button>
            <button mat-flat-button id="cancel" (click)="cancelChanges()">Cancelar</button>
        </div>
    </div>
</div>